import type { ProjectIssueType } from '@atlassian/jira-issue-gira-transformer-types/src/common/types/project.tsx';
import type { ProjectIssueType as IssueType } from '@atlassian/jira-issue-shared-types/src/common/types/project-type.tsx';

export const transformIssueType = (issueType: ProjectIssueType): IssueType => ({
	id: Number(issueType.id),
	name: issueType.name,
	subtask: issueType.subtask,
	iconUrl: issueType.iconUrl,
});
